import { render, staticRenderFns } from "./DeterminationFileRow.vue?vue&type=template&id=51329a87"
import script from "./DeterminationFileRow.vue?vue&type=script&lang=js"
export * from "./DeterminationFileRow.vue?vue&type=script&lang=js"
import style0 from "./DeterminationFileRow.vue?vue&type=style&index=0&id=51329a87&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51329a87')) {
      api.createRecord('51329a87', component.options)
    } else {
      api.reload('51329a87', component.options)
    }
    module.hot.accept("./DeterminationFileRow.vue?vue&type=template&id=51329a87", function () {
      api.rerender('51329a87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/DeterminationDocuments/DeterminationFileRow.vue"
export default component.exports